//angular
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//others
import * as auth0 from 'auth0-js';
//app
import { AppAnimations } from '../../../_shared/animations';
import { AUTH_CONFIG_DESKTOP } from '../../../../environments/environment';
import { ValidatorService } from '../../../_shared/validators/validator.service';
import { AuthService } from 'src/app/_core/services/auth.service';
import { environment } from 'src/environments/environment';
import { EnvironmentNames } from 'src/app/app.data';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  animations: [ AppAnimations ],
  host: { '[@slideInRightAnimation]': '', 'class': 'display flex' }
})

export class SignInComponent implements OnInit {
  auth0: any;
  enableCreateCompanyButton: boolean = false;
  errCode: string;
  errMessage: string;
  hide: boolean = true;
  messageStatus: string = 'hidden';
  form: FormGroup;
  formSubmitted: boolean = false;

  constructor(
    public _auth: AuthService,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _fb: FormBuilder,
    private _validatorService: ValidatorService,
  ) {
    this._iconRegistry.addSvgIcon('logo-rebillia', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this._iconRegistry.addSvgIcon('ico-google',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-google-01.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-04.svg'));

    this.auth0 = new auth0.WebAuth({
      audience: AUTH_CONFIG_DESKTOP.audience,
      domain: AUTH_CONFIG_DESKTOP.domain,
      clientID: AUTH_CONFIG_DESKTOP.clientID,
      redirectUri: AUTH_CONFIG_DESKTOP.callbackURL,
      responseType: AUTH_CONFIG_DESKTOP.responseType,
      scope: AUTH_CONFIG_DESKTOP.scope
    });
  }

  setUpForm() {
    this.form = this._fb.group({
      email: ['', [Validators.required, this._validatorService.emptySpace, this._validatorService.email]],
      password: ['', [Validators.required, this._validatorService.emptySpace]]
    });
  };

  ngOnInit() {
    this.setUpForm();
    this.enableCreateCompanyButton = (environment.name != EnvironmentNames.prod);
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    const values = {
      email: this.form.get('email').value,
      password: this.form.get('password').value
    };

    this.login(values);
  }

  login(values){
    this.auth0.login({
      realm: AUTH_CONFIG_DESKTOP.connection,
      username: values.email,
      password: values.password,
    }, (err, authResult) => {
      if (err) {
        this.formSubmitted = !this.formSubmitted;
        this.errCode = err.error;
        this.errMessage = err.errorDescription;
        this.messageStatus = 'visible';
      } else if (authResult && authResult.accessToken && authResult.idToken) {
        this.formSubmitted = !this.formSubmitted;
        this._auth.setSessionUserPass(authResult);
      }
    });
  }

}
